import {createSelector} from 'reselect';
import {itgProcess} from './itgProcess';

export const jsessionId = createSelector(
  itgProcess,
  itgProcess => itgProcess.jsessionId
);
